import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { ensureBoolean, i18nIntl, isNotEmpty } from '../../../lib/ep';

import ActionLink from '../../builder/ActionLink';
import FloatingLayerPublic from '../FloatingLayerPublic';

const EnterButton = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ display_layer, setDisplayLayer ] = useState(false);

	const promotion = props?.promotion ?? false;
	const questions = props?.questions ?? [];
	const is_builder = props?.is_builder ?? false;

	let promo_status = props?.promo_status ?? (window?.promo_status ?? 'closed');
	if(isNotEmpty(promotion, 'promo_status')) promo_status = promotion.promo_status;

	if(promotion === false) return null;

	const display_button = (!ensureBoolean(promotion?.hide_enter_button ?? '0') || questions.length > 0 || promotion.promotion_type_id == '25') ? true : false;
	if(!display_button) return null;

	const icon = props?.icon ?? 'knk-play';

	let default_link = 'register';
	if(questions.length > 0) {
		questions.map((question) => {
			if(default_link != 'quiz' && question.Question.status == '1') {
				default_link = 'quiz';
			}
		});
	}

	const is_multi_participation = ensureBoolean(promotion?.multi_participation ?? false);
	if(is_multi_participation) default_link = 'login';

	const in_widget = props?.in_widget ?? false;
	let autotranslate = props?.autotranslate ?? false;

	let enter_to_vote = promotion?.enter_to_vote ?? false;
	if(!['45', '55', '56', '58'].includes(promotion.promotion_type_id)) enter_to_vote = false;

	let label = props?.children ?? false;
	if(enter_to_vote) {
		default_link = 'gallery';
		if(label === false) label = i18n("vote", 'ucfirst');
		autotranslate = false;
	} else if(label === false) {
		label = (isNotEmpty(promotion?.custom_labels, 'enter_button')) ? promotion?.custom_labels.enter_button : "Enter";
	}

	let link = props?.link ?? `/${default_link}/${promotion.id}`;
	if(in_widget) link += '/?fromwidget=1';

	return (
		<>
			<ActionLink
				icon={icon}
				onClick={(!is_builder && !['open', 'active'].includes(promo_status)) ? () => setDisplayLayer(promo_status) : null}
				_href={(!is_builder && ['open', 'active'].includes(promo_status)) ? link : null}
				autotranslate={autotranslate}
				_class={{ other:'enter_btn' }}
			>{props?.custom_content ?? label}</ActionLink>

			{(display_layer === 'pending') && (
				<FloatingLayerPublic
					title={`<h1>${i18n("Pending promotion")}</h1>`}
					pm={promotion}
					backButton={() => setDisplayLayer(false)}
					is_builder={is_builder}
					autotranslate={autotranslate}
				><p>{i18n("The registration to this promotion will be open soon. Stay tuned and try again.")}</p></FloatingLayerPublic>
			)}

			{(display_layer === 'closed') && (
				<FloatingLayerPublic
					title={`<h1>${i18n("Closed promotion")}</h1>`}
					pm={promotion}
					backButton={() => setDisplayLayer(false)}
					is_builder={is_builder}
				><p>{i18n("Sorry, this promotion is closed for new entries. Thanks!")}</p></FloatingLayerPublic>
			)}
		</>
	)
};

export default injectIntl(EnterButton);